import { Pageheader } from './global-components/page-header';
import BlogSection from './section-components/blog-section';
import bgImage from '../assets/img/bg/ab.webp';

const AmaravatiNews = () => {
    return (
        <div>
            <Pageheader headertitle="Amaravati News" bgImage={bgImage} />
            <BlogSection category="amaravati" />
        </div>
    );
};

export default AmaravatiNews;
